export const CACHE_KEY = 'offline-page';
